export const isSafari =
  navigator.userAgent.toLowerCase().indexOf("safari/") > -1;
